import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.711 14.464s.536 1.24-.137 3.268c.062-.071.68-2.451 3.7-3.465 3.022-1.014 6.372-1.187 5.855-4.837-.518-3.65-7.045-1.338-5.59.076 1.706 1.658 2.48-3.156 1.055-4.413-1.424-1.257-4.652-.643-5.21 1.878s-.484 5.019.705 4.759c1.188-.26.205-3.573-2.419-4.678-2.616-1.156-4.531 3.006-3.998 4.643s2.928-.497.387-2.014-4.74-1.715-4.78 1.99 3.668 4.204 4.636 4.974 1.84 2.613 1.84 2.613-.898-2.987 1.341-4.215"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.67 7.052c-1.766-.78-3.213.863-3.802 2.517m0 0c-.284.796-.37 1.594-.196 2.126.533 1.638 2.928-.497.387-2.014zm0 0c-2.46-1.413-4.55-1.51-4.589 2.102-.04 3.706 3.668 4.204 4.636 4.974s1.84 2.613 1.84 2.613-.898-2.987 1.341-4.215"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const RelationshipIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
